import React from 'react'
import styled from 'styled-components'
import { tryExtractPixelProperty } from '~/utils/css'

const EllipseWrapper = styled.div`
  justify-content: center;
  align-items: center;
`

interface StyledEllipseProps {
  $height: number
  $width: number
  $color: string
  $margin?: string | number
  $outline?: string
  $outlineColor?: string
}

const StyledEllipse = styled.span<StyledEllipseProps>`
  display: flex;
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
  border-radius: ${(props) => props.$height / 2}px;
  background-color: ${(props) => props.$color};
  margin: ${(props) => tryExtractPixelProperty(props.$margin)};
`
interface EllipseProps {
  height: number
  width: number
  color: string
  margin?: string | number
  outline?: string
  outlineColor?: string
}

const Ellipse = ({ height, width, color, margin }: EllipseProps) => {
  return (
    <EllipseWrapper>
      <StyledEllipse
        $height={height}
        $width={width}
        $color={color}
        $margin={margin}
      />
    </EllipseWrapper>
  )
}

export default Ellipse
